import { render, staticRenderFns } from "./branch-institute.vue?vue&type=template&id=30e99444&scoped=true"
import script from "./branch-institute.vue?vue&type=script&lang=js"
export * from "./branch-institute.vue?vue&type=script&lang=js"
import style0 from "./branch-institute.vue?vue&type=style&index=0&id=30e99444&prod&lang=less&scoped=true"
import style1 from "./branch-institute.vue?vue&type=style&index=1&id=30e99444&prod&lang=less"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "30e99444",
  null
  
)

export default component.exports